<div class="relative bg-primary-50">
  <button
    mat-mini-fab
    aria-label="close"
    color="warn"
    type="button"
    class="!absolute right-1 top-1 z-10 !shadow-none md:right-2.5 md:top-2.5"
    [mat-dialog-close]="false">
    <mat-icon class="!text-white">close</mat-icon>
  </button>

  <span mat-dialog-title class="!block w-full max-w-[90%] !truncate">
    {{ 'Se ha producido un error en la aplicación' | translate }}.
  </span>
</div>

<mat-dialog-content>
  <p>
    {{
      'Es posible que el error sea algo temporal, por lo que puedes intentarlo de nuevo'
        | translate
    }}.
  </p>
  <p class="flex items-center gap-0.5">
    {{ 'Si no se soluciona el problema contacta con nosotros' | translate }}.
    @if (!showErrorDetails) {
      <span (click)="onShowErrorDetails()">
        <mat-icon
          class="more-info-icon !mt-1"
          [matTooltip]="'Más información del error' | translate"
          >error_outline</mat-icon
        >
      </span>
    }
  </p>
  @if (showErrorDetails) {
    <mat-card class="!shadow-none">
      <mat-card-header>
        <mat-card-title>{{
          'Información técnica del error' | translate
        }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          {{
            'El siguiente código contiene información útil para nuestros técnicos a la hora de detectar y corregir el error'
              | translate
          }}.
        </p>
        <code>
          @if (isControlledError) {
            <div class="mb-3">
              <strong
                >{{ error?.error?.errors[0]?.code }}:
                {{ error?.error?.errors[0]?.title }}</strong
              >
              @if (error?.error?.errors[0]?.detail) {
                <em class="pl-1">{{ error?.error?.errors[0]?.detail }}</em>
              }
            </div>
          }
          <div><strong>Url:</strong> {{ error?.url }}</div>
          <div><strong>Status:</strong> {{ error?.status }}</div>
          <div><strong>StatusText:</strong> {{ error?.statusText }}</div>
          <div><strong>Message:</strong> {{ error?.message }}</div>
        </code>
      </mat-card-content>
    </mat-card>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="!mb-3">
  <button
    mat-flat-button
    aria-label="close"
    color="warn"
    type="button"
    class="!text-white"
    [mat-dialog-close]="true"
    cdkFocusInitial>
    <mat-icon>close</mat-icon> {{ 'Cerrar' | translate }}
  </button>
</mat-dialog-actions>
